"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuctionHouseList = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var nft_hooks_1 = require("@zoralabs/nft-hooks");

var useMediaContext_1 = require("../context/useMediaContext");

var NFTPreview_1 = require("../nft-preview/NFTPreview");

var AuctionHouseList = function AuctionHouseList(_ref) {
  var curatorIds = _ref.curatorIds,
      _ref$approved = _ref.approved,
      approved = _ref$approved === void 0 ? true : _ref$approved,
      onClick = _ref.onClick;

  var _nft_hooks_1$useAucti = nft_hooks_1.useAuctions(curatorIds, approved),
      data = _nft_hooks_1$useAucti.data,
      loading = _nft_hooks_1$useAucti.loading,
      error = _nft_hooks_1$useAucti.error;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles;

  if (loading || error) {
    return jsx_runtime_1.jsx("span", {
      children: "..."
    }, void 0);
  }

  return jsx_runtime_1.jsx("div", Object.assign({}, getStyles("auctionHouseList"), {
    children: data && data.map(function (auction) {
      return jsx_runtime_1.jsx(NFTPreview_1.NFTPreview, {
        id: auction.tokenId,
        contract: auction.tokenContract,
        onClick: onClick ? function (evt) {
          return onClick(evt, auction);
        } : undefined
      }, auction.id);
    })
  }), void 0);
};

exports.AuctionHouseList = AuctionHouseList;